<template>
  <div>
    <div>
      กรุณาเลือกภาค<br />
      ราศรี : {{ $store.state.form.zodiac }} ภาค :
      {{ $store.state.form.location }}
    </div>
    <div>
      <b-button variant="outline-primary" @click="location1">เหนือ</b-button>
      <b-button variant="outline-primary" @click="location2">ใต้</b-button>
      <b-button variant="outline-primary" @click="location3">ออก</b-button>
      <b-button variant="outline-primary" @click="location4">ตก</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {
      location1() {
        this.$store.dispatch("setFrom", {
          location: "เหนือ",
        });
        this.$router.push("/page3");
      },
      location2() {
        this.$store.dispatch("setFrom", {
          location: "ใต้",
        });
        this.$router.push("/page3");
      },
      location3() {
        this.$store.dispatch("setFrom", {
          location: "ออก",
        });
        this.$router.push("/page3");
      },
      location4() {
        this.$store.dispatch("setFrom", {
          location: "ตก",
        });
        this.$router.push("/page3");
      },
    },
  };
</script>

<style scoped></style>
